var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.39a3.69 3.69 0 11-.06-7.38 3.69 3.69 0 01.06 7.38zm0-5.62a1.94 1.94 0 10-.06 3.88A1.94 1.94 0 0011 6.77zM11 21.83a9.84 9.84 0 01-7.68-3.63l-.22-.27v-.35a4.89 4.89 0 014.9-4.5h6a4.89 4.89 0 014.84 4.5v.35l-.22.27A9.85 9.85 0 0111 21.83zm-6.08-4.45a8.13 8.13 0 0012.1 0 3.13 3.13 0 00-3-2.55H8a3.12 3.12 0 00-3.08 2.55zM19.37 4h-1.75v5h1.75V4z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.62h-5v1.75h5V5.62z",
    fill: "#121314"
  })));
}
export default SvgLarge;